var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-h6 mb-4 grey--text"},[_vm._v("E-Mail Templates")]),_c('v-container',{staticClass:"my-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }